<template>
    <api-tokens :tokens="tokens" :loading="loading"></api-tokens>
</template>

<script>
import ApiTokens from './ApiTokens.vue';

import axios from '~/services/axios';

export default {
    components: {
        ApiTokens,
    },

    /**
     * The component's data.
     */
    data() {
        return {
            tokens: [],
            loading: false,
        };
    },

    /**
     * Prepare the component.
     */
    mounted() {
        this.getTokens();
    },

    /**
     * The component has been created by Vue.
     */
    created() {
        Bus.$on('updateTokens', () => {
            this.getTokens();
        });
    },

    methods: {
        /**
         * Get the current API tokens for the user.
         */
        getTokens() {
            this.loading = true;

            axios
                .get('/settings/api/tokens')
                .then((response) => (this.tokens = response.data))
                .finally(() => (this.loading = false));
        },
    },
};
</script>
